import { useEffect, useState } from 'react';
import { useResizeScreen } from "../../../hooks/useResizeScreen";
import useStyles from "../../../assets/styles/styles";
import {
    Typography,
    Divider,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Box
} from "@material-ui/core";
import CustomButton from '../../../controls/Button/CustomButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { getVitalParameters } from './../../../redux/actions/medicalDataAction';
import { useDispatch, useSelector } from "react-redux";
import NotFound from '../../HomeLogged/NotFound';
import { handleGoToPersonalMedicalData } from "../../../utils/utilsFunctions";
import FormHeader from '../../PersonalData/FormHeader';
import MovementsCard from '../../Billing/Movements/MovementsCard';
import HeaderCard from '../../Billing/Movements/HeaderCard';
import Loading from '../../LoadingPage/Loading';
import ShowPeriodFilterParameter from '../../ShowPeriodFilter/ShowPeriodFilterParameter';

const VitalParameters = (props) => {
    const today = new Date();
    today.setMonth(-6);
    const dispatch = useDispatch();
    const classes = useStyles();
    const { screen } = useResizeScreen();
    const [open, setOpen] = useState(false);
    const [dateStart, setDateStart] = useState(today);
    const [dateEnd, setDateEnd] = useState(new Date());
    const [skip, setSkip] = useState(0);
    const [vitalParameters, setVitalParameters] = useState([]);
    const [selectedFilter, setFilter] = useState(null);
    const [switchState, setSwitchState] = useState({});
    const [lastRecord, setLastRecord] = useState(null);
    const filterTypes = ["TODOS", "TEMPERATURA", "TENSION ARTERIAL", "GLUCEMIA", "FRECUENCIA CARDIACA"];
    const medicalData = useSelector(state => state.medicalDataReducer);
    const [loadingLastRecord, setLoadingLastRecord] = useState(true);

    useEffect(() => {
        setFilter("TODOS");
        const newSwitch = {
            "TODOS": true,
            "TEMPERATURA": false,
            "TENSION ARTERIAL": false,
            "GLUCEMIA": false,
            "FRECUENCIA CARDIACA": false
        };
        setSwitchState(newSwitch);
    }, []);

    useEffect(() => {
        setLoadingLastRecord(true)
        if (medicalData.vitalParameters.parametrosVitales !== undefined && medicalData.vitalParameters.parametrosVitales.length > 0) {
            if (vitalParameters.length !== 0) {
                const newRegisters = vitalParameters;
                medicalData.vitalParameters.parametrosVitales.forEach(element => {
                    newRegisters.push(element);
                });
                setVitalParameters(newRegisters);
            }
            else {
                setLastRecord(medicalData.vitalParameters.parametrosVitales[0]);
                setVitalParameters(medicalData.vitalParameters.parametrosVitales);
                setLoadingLastRecord(false);
            }
        }
        setLoadingLastRecord(false)
    }, [medicalData.vitalParameters]);

    useEffect(() => {
        filterDate();
    }, [dateEnd]);

    useEffect(() => {
        filterDate();
    }, [dateStart]);

    useEffect(() => {
        filterDate();
    }, [selectedFilter]);

    const filterDate = () => {
        setLastRecord(null);
        setLoadingLastRecord(true);
        setVitalParameters([]);
        callToServices();
    };

    const handleChangeFilter = (event) => {
        if (event.target.name !== "TODOS" || event.target.name == "TODOS" && event.target.checked) {
            const defaultSwitch = {
                "TODOS": !event.target.checked,
                "TEMPERATURA": false,
                "TENSION ARTERIAL": false,
                "GLUCEMIA": false,
                "FRECUENCIA CARDIACA": false
            };
            setFilter(event.target.checked ? event.target.name : "TODOS");
            setSwitchState({ ...defaultSwitch, [event.target.name]: event.target.checked });
        }
    };

    const callToServices = (skipValue) => {
        let aux = skipValue ? parseInt(skipValue) : 0;

        if (dateStart !== null && dateEnd !== null) {
            if (selectedFilter) {
                const paramGet = {
                    numeroPersona: parseInt(window.localStorage.getItem("numeroPersona")),
                    count: 10,
                    skip: aux,
                    parametroVitalTipo: selectedFilter,
                    fechaDesde: dateStart,
                    fechaHasta: dateEnd
                };

                setSkip(aux);
                dispatch(getVitalParameters(paramGet));
            }
        }
    };

    const lastRecordCard = () => {
        return <>
            {lastRecord !== null ?
                (
                    <MovementsCard
                        buttonsInHeader={false}
                        headerIcon={
                            <HeaderCard
                                day={lastRecord?.fechaFormateada?.nombreDia}
                                numberDay={lastRecord?.fechaFormateada?.dia}
                                month={parseInt(lastRecord?.parametroVitalFechaRegistracion?.substring(5, 7))}
                                year={lastRecord?.parametroVitalFechaRegistracion?.substr(0, 4)}
                            />
                        }
                        description={<Box className={classes.descriptionlastRegistrationCard}>
                            <Typography className={`${classes.txtSubtitleCalendar} ${classes.txtEllipsis}`}>
                                {`HORA: ${lastRecord?.parametroVitalFechaRegistracion?.substr(lastRecord?.parametroVitalFechaRegistracion.indexOf("T") + 1)} hs`}
                            </Typography>
                            <Typography className={`${classes.subTitleMedicalData} ${classes.txtEllipsis}`}>{lastRecord?.parametroVitalTipo}</Typography>
                            {lastRecord?.paramentrosVitalValores.map((item, i) => (
                                <Box key={i} className={classes.displayFlex}>
                                    <Typography
                                        className={`${classes.tctDescriptionLastRegistrationCard} ${classes.txtEllipsis}`}>
                                        {item.valorDescripcion + " "}
                                    </Typography>
                                    <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis}`}>
                                        {`${item.valor} ${units(lastRecord.parametroVitalTipo)}`}
                                    </Typography>
                                </Box>
                            ))
                            }
                        </Box>}
                    />
                )
                : (
                    <Box className={classes.txtBoxNotFound}>
                        <NotFound customMsg={
                            <Box className={classes.contentNotFound}>
                                <Typography>
                                    No se encontraron resultados
                                </Typography>
                            </Box>
                        }
                            wsItem={medicalData?.vitalParameters?.parametrosVitales}
                            fullItem={medicalData?.vitalParameters}
                        />
                    </Box>
                )
            }
        </>;
    };

    const units = (desc) => {
        let response = "";
        switch (desc) {
            case "TENSION ARTERIAL":
                response = "mm de Merc.";
                break;
            case "FRECUENCIA CARDIACA":
                response = "lat/min";
                break;
            case "TEMPERATURA":
                response = "°C";
                break;
            case "GLUCEMIA":
                response = "mg/dl";
                break;
            default:
                break;
        }
        return response;
    };

    const addAccordion = (i, item) => {
        return (
            <Accordion key={i} expanded={true}>
                <AccordionSummary
                    aria-expanded={true}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Box className={classes.boxVitalParameterType}>
                        <Typography className={classes.txtSubtitleCalendar}>
                            {item.parametroVitalTipo}
                        </Typography>
                        <IconButton className={classes.padding0} onClick={() => { handleDelete(item); }}>
                            <DeleteOutlineIcon />
                        </IconButton>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    {
                        item.paramentrosVitalValores.map((value, key) => (
                            <Box key={key} className={classes.displayFlex}>
                                <Typography className={`${classes.txtVitalParameterType} ${classes.txtEllipsis}`}>{value.valorDescripcion}</Typography>
                                <Typography className={`${classes.txtSubtitleGray} ${classes.txtEllipsis}`}>
                                    {`${value.valor} ${units(item.parametroVitalTipo)}`}
                                </Typography>
                            </Box>
                        ))
                    }
                    <Box className={classes.displayFlex}>
                        <Typography className={`${classes.txtVitalParameterType} ${classes.txtEllipsis}`}>{"FECHA Y HORA:"}</Typography>
                        <Typography className={`${classes.txtSubtitleGray} ${classes.txtEllipsis}`}>{item.parametroVitalFechaRegistracion.replace("T", " ")}</Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>);
    };



    const scrollDiv = () => {
        return (screen.sWidth < 800 ? classes.heightDivRegisters : "");
    };

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) {
            callToServices();
        }
    };


    const handleDelete = (item) => {
        const param = {
            numeroPersona: parseInt(window.localStorage.getItem("numeroPersona")),
            parametroVitalTipo: item?.parametroVitalTipo?.trim(),
            parametroVitalValores: JSON.stringify(item.paramentrosVitalValores),
            parametroVitalFechaRegistracion: item.parametroVitalFechaRegistracion,
            modo: "B"
        };
        param.modo = "B";
        props.setAction("BAJA");
        props.setForm(param);
        props.setOpenConfirm(prevState => !prevState);
    };

    function formHeaderText() {
        const response = {
            titleHeader: 'Parametros vitales',
            subtitleHeader: 'Información sin carácter sanitario conforme ley Nº 26529'
        };
        if (screen.sWidth < 768) {
            response.titleHeader = 'Mis datos medicos';
            response.subtitleHeader = 'Información sin carácter sanitario conforme ley Nº 26529';
        }
        return response;
    }

    function showLastCardRecord() {
        return (
            <Box className={classes.viewShowLastCardRecord}>
                {lastRecordCard()}
            </Box>
        );
    }

    function myLastRecord() {
        return (
            <Box>
                <Box className={classes.boxLastVitalSignsRecord}>
                    <Typography className={`${classes.titleTurn} ${classes.titleBox}`}>
                        MI ULTIMO REGISTRO
                    </Typography>
                    <Divider className={classes.formDividerVitalSigns} />
                    {showLastCardRecord()}
                </Box>

                <Typography className={`${classes.titleTurn} ${classes.titleBox}`}>
                    MIS REGISTROS ANTERIORES
                </Typography>
                <Divider className={classes.formDividerVitalSigns} />
                <Box
                    className={`${classes.flexRowAcordion} ${scrollDiv()}`}
                    onScroll={(e) => { handleScroll(e); }}
                >
                    {
                        vitalParameters?.length > 0 ? <> {
                            vitalParameters.map((item, i) => (
                                <Box key={i} className={`${classAccordion(screen.sWidth, classes)} ${classes.marginBottom}`} style={{ marginLeft: screen.sWidth > 768 && '40px' }}>
                                    {addAccordion(i, item)}
                                </Box>
                            ))
                        }
                            {screen.sWidth > 800 && vitalParameters?.length > 10 &&
                                <Box className={classes.btnMobileVitalSigns} >
                                    <CustomButton customClass={classes.btnViewVitalSigns} title='ver mas' onClick={(event) => {
                                        callToServices(skip + 10);
                                    }} />
                                </Box>
                            }
                        </> :
                            (
                                <Box className={classes.txtBoxNotFound}>
                                    <NotFound customMsg={
                                        <Box className={classes.contentNotFound}>
                                            <Typography>
                                                No se encontraron resultados
                                            </Typography>
                                        </Box>
                                    }
                                        wsItem={medicalData?.vitalParameters?.parametrosVitales}
                                        fullItem={medicalData?.vitalParameters}
                                    />
                                </Box>
                            )
                    }
                </Box>
            </Box>
        );
    }

    return (<>
        {
            screen.sWidth <= 768 &&
            <FormHeader title={formHeaderText().titleHeader} subtitle={formHeaderText().subtitleHeader} handleGoTo={handleGoToPersonalMedicalData} />
        }
        <Box className={`${classes.headerSecundary} ${classes.headingVitalSigns}`} >
            <Typography className={`${classes.titleVitalSigns} ${classes.titleBox}`}>
                PARAMETROS VITALES
            </Typography>
            <Typography className={`${classes.titleTurn} ${classes.subtitleBoxVitalSigns}`}>
                Información sin carácter sanitario conforme ley Nº 26529
            </Typography>
            <Box  className={classes.headerFilterVitalSigns}>
                <CustomButton
                    title={"NUEVO "}
                    onClick={() => { props.setAdd(prevState => !prevState); }}
                    customClass={`${classes.btnNewWeigth} ${classes.lightLinearGradient} `}
                    style={{ margin: "0 10px" }}
                />
                <ShowPeriodFilterParameter
                    dateStart={dateStart}
                    dateEnd={dateEnd}
                    setDateStart={setDateStart}
                    setDateEnd={setDateEnd}
                    openPicker={open}
                    setOpenPicker={setOpen}
                    classes={classes}
                    filterTypes={filterTypes}
                    switchState={switchState}
                    handleChangeFilter={handleChangeFilter}
                />
            </Box>
        </Box>
        <Loading
            isLoading={loadingLastRecord}
            children={myLastRecord()}
        />
    </>);
};

export default VitalParameters;


function classAccordion(swidth, classes) {
    if (swidth > 800) {
        return classes.AccordionWeightWeb;
    }
    else {
        return classes.AccordionWeightMobile;
    }
}